import React, { Component, Fragment } from 'react'
import classnames from 'classnames'

import { Loan } from './types'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchLoan: Callback
  loan: Loan
  match: Match<ParamsID>
}

export class UnderwritingDecisionHistory extends Component<Props> {
  render() {
    const { loan } = (this.props || {}) as Partial<NonNullable<Props>>
    if (!loan) return null
    if (Object.keys(loan).length === 0) return null

    const attributes = {
      id: 'ID',
      decisionAt: 'Decision At',
      action: 'Action',
      decision: 'Decision',
      status: 'Status',
      declinePendingAt: 'Decline Pending At',
      adminStatus: 'Admin Status',
      updatedByName: 'Updated By',
      tier: 'Credit Tier',
      score: 'Score',
      preciseScore: 'Precise Score',
      ofacScore: 'OFAC Score',
      softPullAt: 'Soft Pull At',
      hardPullAt: 'Hard Pull At',
      statedGrossIncome: 'Stated Gross Income',
      income: 'Income',
      debt: 'Debt',
      rawDebt: 'Raw Debt',
      adminNote: 'Admin Note',
      ruleVersion: 'Rule Version',
      pti: 'PTI',
      dti: 'DTI',
      adverseActions: 'Adverse Actions',
      failedRules: 'Failed Rules',
      ruleWaivers: 'Rule Waivers',
      tradelineOverrides: 'Tradeline Overrides',
      amountFinanced: 'Amount Financed',
      warrantyFee: 'Warranty Fee',
      term: 'Term',
      downPayment: 'Down Payment',
      tradeinAllowance: 'Trade-in Allowance',
      price: 'Price',
      offerPayment: 'Offer Payment',
      offerApr: 'Offer APR',
      apr: 'Loan APR',
      creditValid: 'Credit Valid',
    }

    const renderColumns = (key) => {
      const eachWithPrevious = (array) => {
        return array.map((item, index) => {
          const prev = index > 0 ? array[index - 1] : null
          return [prev, item]
        })
      }

      const columns = eachWithPrevious(loan.decisionHistory).map(
        ([previous, decision], index) => {
          const currentValue = decision[key]
          const previousValue = previous && previous[key]
          const isDifferent = previousValue && previousValue !== currentValue

          return (
            <td
              key={`col-${key}-${index}`}
              className={classnames({ highlightdiff: isDifferent })}
            >
              {currentValue}
            </td>
          )
        }
      )

      return <Fragment>{columns}</Fragment>
    }

    const tableContent = Object.keys(attributes).map((key) => {
      if (!loan.decisionHistory) return null

      const label = attributes[key]
      const columns = renderColumns(key)

      return (
        <tr key={`row-${key}`}>
          <th>{label}</th>
          {columns}
        </tr>
      )
    })

    return (
      <div className="content">
        <table className="table rounded-table table-striped-column credit-decision-history-table">
          <tbody>
            {tableContent}
            {/*
            <tr>
            <th>Loan apr</th>
            <td class="table-text-center-aligned">%</td>
            <td class="table-text-center-aligned highlightdiff">3.9%</td>
            <td class="table-text-center-aligned">3.9%</td>
            <td class="table-text-center-aligned">3.9%</td>
            </tr>
            <tr>
            */}
          </tbody>
        </table>
      </div>
    )
  }
}
